import { EVIDENTLY_FLAG } from '~/util/constants/keys'

const builtinTypes: string[] = [
  'image',
  'gallery',
  'video',
  'raw_html',
  'audio',
]

export const getBuiltinTypes = (
  evidentlyFeatures: Record<string, boolean> | undefined
): string[] => {
  if (
    evidentlyFeatures &&
    evidentlyFeatures[EVIDENTLY_FLAG.AUDIO_CENTER_INTEGRATION] === false
  ) {
    return builtinTypes.filter((type) => type !== 'audio')
  }
  return builtinTypes
}

export default builtinTypes
